/* eslint-disable camelcase */
import it_IT from './it_IT';
import en from './en_EN';

export default { it_IT, en };
